import { addParamsToHref } from '@noths/polaris-client-utils';

export const SEARCH_RESULTS_PATH = '/search';

export const buildSearchListingsPagePath = (term: string, suggestionPosition?: number) => {
  return addParamsToHref(SEARCH_RESULTS_PATH, {
    term,
    ...(suggestionPosition !== undefined && { suggestionPosition }),
  });
};
